var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaution(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3164_24345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.00033 12C2.69134 12 0 9.30866 0 6.00033C0 2.692 2.69134 0 6.00033 0C9.30933 0 12.0007 2.69134 12.0007 6.00033C12.0007 9.30932 9.30933 12 6.00033 12ZM6.00033 0.664857C3.05834 0.664857 0.664857 3.05834 0.664857 6.00033C0.664857 8.94232 3.05834 11.3351 6.00033 11.3351C8.94232 11.3351 11.3358 8.94166 11.3358 6.00033C11.3358 3.05901 8.94166 0.664857 6.00033 0.664857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.44922 8.63111C5.44922 8.29536 5.68258 8.05202 5.99972 8.05202C6.33547 8.05202 6.55022 8.29469 6.55022 8.63111C6.55022 8.96753 6.33547 9.2102 5.99972 9.2102C5.66397 9.2102 5.44922 8.95822 5.44922 8.63111ZM5.68258 7.29608L5.55161 2.81494H6.44783L6.31686 7.29608H5.68192H5.68258Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3164_24345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/caution.b1175883.svg";
export { ForwardRef as ReactComponent };